module.exports = __webpack_public_path__ + "static/img/1001.8870c62.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/templates/1001.png
// module id = 730
// module chunks = 0 1 12